import Blue from "~/core";

new Blue({
	name: 'Interior Nav',
	selector: ".int-nav",
	setup(container) {
		const triggers = [...container.querySelectorAll(".int-nav__primary-trigger")];
    const mobileTrigger = container.querySelector(".int-nav__heading");
		const nav = container.querySelector("nav.int-nav__nav");
		const minScreenWidth = 767;
		const header = document.querySelector("header.header") || false;

		const relations = [];
		const mobileRelations = []

		// INITIATE NAV ACCORDIONS
		triggers.forEach(trigger => {
			const parent = trigger.closest(".int-nav__primary-item");
			const content = parent.querySelector(".int-nav__secondary");
			let config = {
				container: parent,
				trigger,
				content,
				relations
			}
			relations.push(new this.$toggle(config));
		});
		// OPEN THE ACCORDION WITH THE ACTIVE PAGE IN ITS SUB MENU
		const activeLink = container.querySelector(".int-nav__item--active");
		const activeItem = activeLink.closest(".int-nav__primary-item");
		activeItem.querySelector(".int-nav__primary-trigger").click();

		const initMobileAccordion = () => {
			let trigger = mobileTrigger;
			let content = nav;
			let config = {
				container,
				trigger,
				content,
				mobileRelations
			}
			mobileRelations.push(new this.$toggle(config));
		}

		if (window.innerWidth < minScreenWidth) {
			initMobileAccordion();
		}

		this.$addEvents(window, "resize", () => {
			if (window.innerWidth < minScreenWidth && relations.length === 0) {
				initMobileAccordion();
			} else if (window.innerWidth < minScreenWidth) {
				nav.style.height = "";
				nav.style.visibility = "";
				nav.style.opacity = "";
			} else if (window.innerWidth >= minScreenWidth) {
				nav.style.height = "auto";
				nav.style.visibility = "visible";
				nav.style.opacity = "1";
			}
		});

		if (header) {
			const main = document.querySelector("main");
			this.$retach(container, {
				destination: main, 
				mediaQuery: minScreenWidth,
				moveMethod: 'prepend', 
			});
		}

	}
});